import React from 'react';

// Constants
import {
  PrimaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';

// Components
import NavMapper from 'components/navV2/NavMapper';

// Styles
import { SecondaryNavWrapper } from './SecondaryNav.styles';

type SecondaryNavProps = {
  secondaryNavData: SecondaryNavItem[];
  activeSecondaryLink: string;
};

const SecondaryNav = (props: SecondaryNavProps): JSX.Element => {
  const { secondaryNavData, activeSecondaryLink } = props;

  // Filters "More" from registry secondary nav, which should only be shown on mweb & tablet
  const filteredSecondaryNavData = secondaryNavData.filter(
    (node) => !(node.parent === PrimaryNavIdentifier.REGISTRY && node.id === 'registry-more')
  );

  return (
    <SecondaryNavWrapper>
      <NavMapper
        activeLinkId={activeSecondaryLink}
        className="navSecondary__container--postAuthNavV3"
        navData={filteredSecondaryNavData}
        type="Secondary"
      />
    </SecondaryNavWrapper>
  );
};

export default SecondaryNav;
